import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageClass } from '../helpers/local-storage-helper';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  private readonly router = inject(Router);

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const token = LocalStorageClass.retrieveTokenFromStorage();

    if (!token?.length) {
      this.router.navigate(['login']).then(() => {
        window.location.reload();
      });

      return false;
    }

    return true;
  }
}
